import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Form, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import Button from 'src/components/common/button/button';

import styles from './birthtime-step.module.scss';

const MIN_VALUE = 0;
const MAX_VALUE_HOURS = 12;
const MAX_VALUE_MINUTES = 59;

export const BirthtimeStep = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (value: string) => void;
}) => {
  const [toggleValue, setToggleValue] = useState(
    value ? value.slice(6, 8) : 'am',
  );

  const [inputValueHours, setInputValueHours] = useState(
    value ? value.slice(0, 2) : '',
  );
  const [inputValueMinutes, setInputValueMinutes] = useState(
    value ? value.slice(3, 5) : '',
  );
  const handleChangeTimeFormat = (value_: string) => {
    setToggleValue(value_);
  };

  const handleChangeTime = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let newValue = Number.parseInt(event.target.value, 10);
      const maxValue =
        event.target.id === 'hours' ? MAX_VALUE_HOURS : MAX_VALUE_MINUTES;

      // Проверяем, что newValue находится в диапазоне [MIN_VALUE_HOURS, MAX_VALUE_HOURS]
      if (newValue < MIN_VALUE) {
        newValue = MIN_VALUE;
      } else if (newValue > maxValue) {
        newValue = maxValue;
      }

      // Добавляем ведущий ноль, если newValue однозначное число
      event.target.id === 'hours'
        ? setInputValueHours(newValue.toString().padStart(2, '0'))
        : setInputValueMinutes(newValue.toString().padStart(2, '0'));
    },
    [],
  );

  return (
    <Form
      className={styles.container}
      onSubmit={(event) => {
        event.preventDefault();
        onChange(`${inputValueHours}:${inputValueMinutes} ${toggleValue}`);
      }}>
      <Form.Group className={styles.timeContainer}>
        <Form.Control
          className={styles.timeInput}
          type="number"
          id="hours"
          placeholder="12"
          value={inputValueHours}
          onChange={handleChangeTime}
          inputMode="numeric"
        />
        <Form.Control
          className={styles.timeInput}
          type="number"
          id="minutes"
          placeholder="00"
          value={inputValueMinutes}
          onChange={handleChangeTime}
          inputMode="numeric"
        />
        <ToggleButtonGroup
          className={styles.toggleContainer}
          type="radio"
          name="options"
          defaultValue="am"
          value={toggleValue}
          onChange={handleChangeTimeFormat}>
          <ToggleButton
            id="am"
            value="am"
            className={classNames(
              styles.toggleButton,
              toggleValue === 'am' && styles.toggleButtonChecked,
            )}
            variant="accent-2">
            AM
          </ToggleButton>
          <ToggleButton
            id="pm"
            value="pm"
            className={classNames(
              styles.toggleButton,
              toggleValue === 'pm' && styles.toggleButtonChecked,
            )}
            variant="accent-2">
            PM
          </ToggleButton>
        </ToggleButtonGroup>
      </Form.Group>

      <Button
        type="submit"
        className={styles.submitButton}
        disabled={inputValueHours == '' && inputValueMinutes == ''}>
        Next
      </Button>
    </Form>
  );
};
